export const reserveItems = [
  '予約数', '事前予約数', '当日予約数', '新規予約数', 'リピート数', ...(FEATURE_NET_RESV ? ['ネット予約数'] : []),
  '成約数', '事前成約数', '当日成約数', '新規成約数', 'リピート成約数', ...(FEATURE_NET_RESV ? ['ネット成約数'] : []),
  'カード数', '電子マネー数',
];

export const cancelItems = [
  'キャンセル数', '事前予約のキャンセル数', '当日予約のキャンセル数', '新規予約のキャンセル数', 'リピート予約のキャンセル数',
  '悪質キャンセル数', '事前予約の悪質キャンセル数', '当日予約の悪質キャンセル数', '新規予約の悪質キャンセル数', 'リピート予約の悪質キャンセル数',
  'キャンセル数(店事由)', '事前予約のキャンセル数(店事由)', '当日予約のキャンセル数(店事由)', '新規予約のキャンセル数(店事由)', 'リピート予約のキャンセル数(店事由)',
  'キャンセル数(女子事由)', '事前予約のキャンセル数(女子事由)', '当日予約のキャンセル数(女子事由)', '新規予約のキャンセル数(女子事由)', 'リピート予約のキャンセル数(女子事由)',
];

export const optionItems = [
  '有料オプション数', '有料オプション料金', '有料オプション報酬',
];

export const payItems = [
  '女子報酬', '報酬補正', '特別手当１', '特別手当２', '特別手当３', '特別手当４', '雑費',
];

export const priceItems = [
  '料金', '料金補正', '料金(カード)', '料金(電子マネー)', '手数料', '料金+手数料', '料金(カード)+手数料', '料金(電子マネー)+手数料',
  '新規予約料金', '割引額', 'お店負担',
];

export const callItems = [
  '着信人数', '新規着信人数', '着信人数(予約)', '着信人数(不成立)', '着信人数(問い合わせ)', '着信人数(拡張1)', '着信人数(新規問い合わせ)',
];

//レポートによって異なる項目(予約関係)
export const reserveItemsMedia = [
  '予約数', '事前予約数', '当日予約数', 'リピート数',
  '成約数', '事前成約数', '当日成約数', 'リピート成約数',
];

export const reserveItemsStaff = [
  '着信受電数', '予約数', '事前予約数', '当日予約数', 'リピート数',
  '成約数', '事前成約数', '当日成約数', 'リピート成約数',
];

export const cancelItemsMedia = [
  'キャンセル数', '事前予約のキャンセル数', '当日予約のキャンセル数', 'リピート予約のキャンセル数',
  '悪質キャンセル数', '事前予約の悪質キャンセル数', '当日予約の悪質キャンセル数', 'リピート予約の悪質キャンセル数',
];

export const cancelItemsStaff = [
  'キャンセル数', '事前予約のキャンセル数', '当日予約のキャンセル数', 'リピート予約のキャンセル数',
  '悪質キャンセル数', '事前予約の悪質キャンセル数', '当日予約の悪質キャンセル数', 'リピート予約の悪質キャンセル数',
];

//レポートによって異なる項目(料金関係)
export const costItemsSales = [
  '求人広告費', '利益', '現金残', '特別収入', '貸付金'
];

export const costItemsMedia = [
  '料金', '料金補正', '女子報酬', '媒体広告費', '利益', 'カード数', '電子マネー数', '手数料',
];

export const costItemsStaff = [
  '料金', '料金補正', '女子報酬', '媒体広告費', '利益', 'カード数', '電子マネー数', '手数料',
];

export const costItemsHime = [
  '利益', '求人広告費',
];

//レポートによって異なる項目(女子関係)
export const himeItemsSales = [
  '出勤数', '出勤時間', 'フリー数', '本指名数', 'ネット指名数', '写真指名数', '姫予約数', 'その他指名数', 'その他2指名数',
];

export const himeItemsHime = [
  '出勤数', '出勤時間', 'フリー数', '本指名数', 'ネット指名数', '写真指名数', '姫予約数', 'その他指名数', 'その他2指名数',
];

export const himeItemsMedia = [
  'フリー数', '本指名数', 'ネット指名数', '写真指名数', '姫予約数', 'その他指名数', 'その他2指名数',
];

export const himeItemsStaff = [
  'フリー数', '本指名数', 'ネット指名数', '写真指名数', '姫予約数', 'その他指名数', 'その他2指名数',
];

export const dailyTotalItems = [
  '売上', '現金売上', 'カード売上', '電子マネー売上', '予約数', '成約数', '現金残', '求人広告費', '経費合計', '女子報酬', '出勤数', '利益', '特別収入', '貸付金', 'お店負担'
];

export const dailyLabalItems = [
  'コース分数', '諸手当', 'オプション', '指名', '延長', 'イベント', 'ホテル', '割引', '着信人数', '特殊'
];

//女子リピート
export const repeatItems = [
  '客人数', '本数', '新規数', '新規以外', '本指名',
  '新規ﾘﾋﾟｰﾄ(30日)', '新規ﾘﾋﾟｰﾄ率(30日)',
  '新規ﾘﾋﾟｰﾄ(60日)', '新規ﾘﾋﾟｰﾄ率(60日)',
  '新規ﾘﾋﾟｰﾄ(90日)', '新規ﾘﾋﾟｰﾄ率(90日)',
  '継続数(30日)', '継続率(30日)',
  '継続数(60日)', '継続率(60日)',
  '継続数(90日)', '継続率(90日)',
];

//金額表記ではないもの
export const exceptPriceItems = [
  ...cancelItems,
  ...himeItemsHime,
  ...callItems,
  ...reserveItems,
  ...repeatItems,
  '着信受電数',
  '予約数(着信)',
  '成約数(デフォルト)',
  '有料オプション数',
  'カード数',
  '電子マネー数',
  '着信人数',
];

//resvごとに何らかの件数をカウントするところ
export const resvCountItems = [
  '事前予約数',
  '当日予約数',
  '新規予約数',
  'リピート数',

  '成約数',
  '新規成約数',
  '事前成約数',
  '当日成約数',
  'リピート成約数',

  'カード数',
  '電子マネー数',
  'フリー数',
  '本指名数',
  '写真指名数',
  'ネット指名数',
  '姫予約数',
  'その他指名数',
  'その他2指名数',

  'キャンセル数',
  '事前予約のキャンセル数',
  '当日予約のキャンセル数',
  '新規予約のキャンセル数',
  'リピート予約のキャンセル数',

  '悪質キャンセル数',
  '事前予約の悪質キャンセル数',
  '当日予約の悪質キャンセル数',
  '新規予約の悪質キャンセル数',
  'リピート予約の悪質キャンセル数',

  'キャンセル数(店事由)',
  '事前予約のキャンセル数(店事由)',
  '当日予約のキャンセル数(店事由)',
  '新規予約のキャンセル数(店事由)',
  'リピート予約のキャンセル数(店事由)',

  'キャンセル数(女子事由)',
  '事前予約のキャンセル数(女子事由)',
  '当日予約のキャンセル数(女子事由)',
  '新規予約のキャンセル数(女子事由)',
  'リピート予約のキャンセル数(女子事由)',
];

export const netResvCountItems = [
  'ネット成約数',
];